import { Injectable, inject } from "@angular/core";
import { PrimeNG } from "primeng/config";
import { TranslateService } from "../util/translate.service";
import { LoggerService } from "../../ancestors/logger.service";

@Injectable({ providedIn: "root" })
export class PrimengConfigService {
  private primeng = inject(PrimeNG);

  private translateService = inject(TranslateService);

  private logger = inject(LoggerService);

  constructor() {
    this.initializeLocale();
  }

  /**
     * Inizializza la localizzazione di PrimeNG basata sulla lingua corrente
     * Le traduzioni sono configurate staticamente nel main.ts
     */
  private initializeLocale(): void {
    // Le traduzioni sono già configurate nel provider providePrimeNG
    // Questo servizio può essere esteso in futuro per gestire cambi di lingua dinamici
    const currentLocale = this.translateService.currentLocale;
    this.logger.info("PrimeNG locale initialized for: " + currentLocale);
  }

  /**
     * Imposta la localizzazione per PrimeNG (per uso futuro)
     * @param locale - Locale da impostare (es. "it-IT", "en-US")
     */
  setLocale(locale: string): void {
    // Per ora le traduzioni sono statiche, ma questo metodo può essere esteso
    // per gestire cambi di lingua dinamici in futuro
    this.logger.info("Setting PrimeNG locale to: " + locale);
  }
}
